import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a68e37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "flex-container" }
const _hoisted_3 = { class: "uk-margin uk-grid-small uk-child-width-auto uk-grid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uk-text-small uk-text-muted uk-text-light uk-text-italic" }, "NOTE: if the checkbox is checked, then it will not install on solutions.engine.net", -1))
const _hoisted_5 = { class: "spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dataSource,
      ref: _ctx.gridRefName,
      height: 440,
      width: 500,
      "show-borders": true,
      "column-auto-width": true,
      "allow-column-resizing": true
    }, {
      add: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_DxButton, {
            width: 170,
            hint: "Add Current Selections To Queue",
            text: "Add To Queue",
            icon: "plus",
            type: "primary",
            "styling-mode": "contained",
            onClick: _ctx.AddToQueue,
            disabled: this.selectedWarehouses.length <= 0 || this.selectedWorkbooks.length <= 0
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      clear: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DxButton, {
            width: 50,
            icon: "clear",
            hint: "Clear Selection",
            type: "primary",
            "styling-mode": "contained",
            onClick: _ctx.clear
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxColumn, {
          "data-field": "warehouseName",
          width: 300,
          "data-type": "string",
          caption: "Warehouse"
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": false,
          "allow-adding": false,
          "allow-deleting": true,
          "confirm-delete": false,
          mode: "row"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "numberOfWorkbooks",
          "data-type": "int",
          caption: "# Of WBs",
          width: 60
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "after",
              template: "add"
            }),
            _createVNode(_component_DxItem, {
              location: "after",
              template: "clear"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "uk-checkbox",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shouldInstallOnCme) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.shouldInstallOnCme]
        ]),
        _createTextVNode(" Install on CME Website")
      ]),
      _hoisted_4
    ]),
    _withDirectives(_createVNode(_component_DxButton, {
      class: "run-button-css",
      width: 120,
      hint: "Run Tableau API For Current Queue",
      text: "Run",
      icon: "video",
      type: "default",
      "styling-mode": "contained",
      onClick: _ctx.RunWorkbooks,
      disabled: this.dataSource.length <= 0
    }, null, 8, ["onClick", "disabled"]), [
      [_vShow, !_ctx.startedRunning]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_5, null, 512), [
      [_vShow, _ctx.startedRunning]
    ])
  ]))
}